// TODO: move to ENV var
export const SHOPPING_CART_REDIRECT_URL = 'https://connectconfigurator-tst.rensa.nl/Configurator/Finish';
export const SHOW_PRICES = 'true' === 'true';




// WEBPACK FOOTER //
// ./js/config/shopping-cart.js